import Form from 'containers/SignupPages/AuthByContractEpargnEmail/Form';
import messages from 'containers/SignupPages/AuthByContractEpargnEmail/messages';
import { PERSONAL_INFO } from 'containers/SignupPages/constants';
import Header from 'containers/SignupPages/Header';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getEmailSelector } from 'store/user/selectors';

export type AuthByContractEmailType = {
  intl: IntlShape;
  onSubmitStep: Function;
  isLoading: boolean;
  setSignupStep: Function;
};

const AuthByContractEmail = (props: AuthByContractEmailType) => {
  return (
    <React.Fragment>
      <Header
        title={translate({ ...messages.title }, props)}
        subTitle={`${translate({ ...messages.subTitle }, props)} :`}
      />
      <Form
        isLoading={props.isLoading}
        onClickPrevious={() => {
          props.setSignupStep(PERSONAL_INFO);
        }}
        onSubmitStep={props.onSubmitStep}
      />
    </React.Fragment>
  );
};

const mapStateToProps = createStructuredSelector<any, { email: string }>({
  email: getEmailSelector,
});

export default connect(mapStateToProps)(injectIntl(AuthByContractEmail));
